import moment, { Moment } from 'moment';

export const buildDatePicker = (value: Moment) => {
  const startDay = moment(value).clone().startOf('month').startOf('week');
  const endDay = moment(value).clone().endOf('month').endOf('week');
  const day = startDay.clone().subtract(1, 'day');
  const calendarArray = [];

  while (day.isBefore(endDay, 'day')) {
    calendarArray.push(
      Array(7)
        .fill(0)
        .map(() => day.add(1, 'day').clone())
    );
  }

  return calendarArray;
};

export const buildToDatePicker = (value: Moment) => {
  const startDay = moment(value)
    .add(1, 'M')
    .clone()
    .startOf('month')
    .startOf('week');
  const endDay = moment(value).add(1, 'M').clone().endOf('month').endOf('week');
  const day = startDay.clone().subtract(1, 'day');
  const calendarArray = [];

  while (day.isBefore(endDay, 'day')) {
    calendarArray.push(
      Array(7)
        .fill(0)
        .map(() => day.add(1, 'day').clone())
    );
  }

  return calendarArray;
};
